import { combineReducers } from "redux";
import authReducer from "../redux/auth/reducers/authReducer";
import verifyEmailReducer from "../redux/auth/reducers/verifyEmailReducer";
import forgotPasswordReducer from "../redux/auth/reducers/forgotPasswordReducer";
import rolesReducer from "./Roles/reducers/rolesReducer";
import customerReducer from "../redux/Customers/reducers/customerReducer";
import vendorReducer from "./Vendors/reducers/vendorReducer";
import airportReducer from "./Airports/reducers/airportReducer";
import staffReducer from "./Staff/StaffReducer";
import changePasswordReducer from "./changePassword/ChangePasswordReducer";
import serviceReducer from "./Service/ServiceReducer";
import selectorReducer from "./Common/selectorReducer";
import resetPasswordReducer from "./auth/reducers/resetPasswordReducer";
import profileUpdateReducer from "./ProfileUpdate/profileUpdateReducer";
import userReducer from "./User/UserReducer";
import uploadReducer from "./UploadCSV/UploadCsvReducer";
import BillingAddressReducer from "./BillingAddress/BillingAddressReducer";
import bookingReducer from "./Bookings/BookingReducer";
import dashboardReducer from "./Dashboard/DashboardReducer";
import familyMemberReducer from "./FamilyMembers/reducer";
import PaymentReducer from "./Payments/PaymentReducer";
import invoiceReducer from "./Invoice/InvoiceReducer";
import notificationReducer from "./notifications/reducer";
import annualReportsReducer from "./annualReports/annualReportsReducer";
import promoCodeReducer from "./PromoCode/PromoCodeReducer.jsx";
import announcementReducer from "./Announcements/announcementReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileUpdateReducer,
  user: userReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  changePassword: changePasswordReducer,
  verifyEmailReducer: verifyEmailReducer,
  roles: rolesReducer,
  customers: customerReducer,
  vendors: vendorReducer,
  airport: airportReducer,
  staffs: staffReducer,
  services: serviceReducer,
  selector: selectorReducer,
  booking: bookingReducer,
  upload: uploadReducer,
  billingAddress: BillingAddressReducer,
  dashboard: dashboardReducer,
  familyMember: familyMemberReducer,
  Payment: PaymentReducer,
  Invoice: invoiceReducer,
  notification: notificationReducer,
  annualReports: annualReportsReducer,
  promoCode: promoCodeReducer,
  announcements: announcementReducer,
});

export default rootReducer;
